export default __webpack_public_path__ + "static/media/pantera.82e42364.svg";